/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import RenderHtml from 'react-native-render-html';
import { View } from '../../components/Themed';
import { RootStackScreenProps } from '../../navigation/navigationTypes';
// Image assets
import SnapCalorieSitePage from '../../components/SnapCalorieSitePage';

const htmlStr = `
  <h1 style="color: rgb(51, 51, 51);">How Much Does SnapCalorie Cost?</h1>
  <p style="color: rgb(51, 51, 51);">If you're wondering how much SnapCalorie's convenient photo based calorie tracker costs you've reached the right spot.</p>
  <div>&nbsp;</div>
  <h3 style="color: rgb(51, 51, 51);">Yearly Pricing</h3>
  <p style="color: rgb(51, 51, 51);">We <b>highly reccomend</b> the yearly pricing option. This option is $199 or just under $17 per month. <b>Why?</b> SnapCalorie encourages slow but sutainable results when it comes to improving your diet.</p>
  <p style="color: rgb(51, 51, 51);">It takes time to achieve sutainable habit change and we want to encourage people to improve their diet long term. We don't believe in short term crash diets.</p>
  <a href="https://www.snapcalorie.com/survey/ValidDevice" style="font-size: 20px; color: rgb(248, 245, 244); background-color: rgb(253, 114, 80); padding: 15px; border-radius: 20px; width: 200px; text-decoration: none; text-align: center; margin: auto;">$17 / month</a>
  <h3 style="color: rgb(51, 51, 51);">Monthly Pricing</h3>
  <p style="color: rgb(51, 51, 51);">For those who aren't ready to commit longer term we offer a flexible monthly option to try out the app in addition to our 7 day free trial. This option is $60 per month.</p>
  <a href="https://www.snapcalorie.com/survey/ValidDevice" style="font-size: 20px; color: rgb(248, 245, 244); background-color: rgb(253, 114, 80); padding: 15px; border-radius: 20px; width: 200px; text-decoration: none; text-align: center; margin: auto;">$60 / month</a>
  <div>&nbsp;</div>
  <h3 style="color: rgb(51, 51, 51);">Alternative Pricing</h3>
  <p style="color: rgb(51, 51, 51);">We don't want money to get in the way of someone improving their diet, health, or longevity. If you can't afford SnapCalorie send us an email at help@snapcalorie.com and we can provide alternative pricing strutures.</p>
`;

const source = {
  html: htmlStr,
};
export default function HowMuchDoesSnapCalorieCost({ navigation }: RootStackScreenProps<'Privacy'>) {
  return (
    <SnapCalorieSitePage
      headerLinks={{
        Home: () => {
          navigation.navigate('Home');
        },
      }}
    >
      <View style={{ alignSelf: 'center', paddingLeft: 40, maxWidth: 800 }}>
        <RenderHtml contentWidth={800} source={source} />
      </View>
    </SnapCalorieSitePage>
  );
}
